<template>
  <v-container fluid class="pa-4">
    <v-card class="elevation-2">
      <v-toolbar color="indigo darken-2" dark dense>
        <v-icon left>event_busy</v-icon>
        <v-toolbar-title>İzin Yönetimi</v-toolbar-title>
        <v-spacer />
        <v-btn icon :loading="loading" @click="load">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <div class="lv-stats">
          <div class="lv-stat">
            <div class="lv-stat-n">{{ leaveStats.total }}</div>
            <div class="lv-stat-l">Toplam Talep</div>
          </div>
          <div class="lv-stat lv-stat--wait">
            <div class="lv-stat-n">{{ leaveStats.pending }}</div>
            <div class="lv-stat-l">Bekleyen</div>
          </div>
          <div class="lv-stat lv-stat--ok">
            <div class="lv-stat-n">{{ leaveStats.approved }}</div>
            <div class="lv-stat-l">Onaylanan</div>
          </div>
          <div class="lv-stat lv-stat--no">
            <div class="lv-stat-n">{{ leaveStats.rejected }}</div>
            <div class="lv-stat-l">Reddedilen</div>
          </div>
          <div class="lv-stat lv-stat--grey">
            <div class="lv-stat-n">{{ leaveStats.cancelled }}</div>
            <div class="lv-stat-l">İptal Edilen</div>
          </div>
          <div class="lv-stat lv-stat--day">
            <div class="lv-stat-n">{{ leaveStats.approvedDays }}<span class="lv-stat-u"> gün</span></div>
            <div class="lv-stat-l">Onaylı İzin Süresi</div>
          </div>
        </div>
        <div v-if="filters.userId" class="lv-scope">
          <v-icon small>person</v-icon>
          Rakamlar seçili kullanıcıya ({{ selectedUserName }}) göre hesaplanıyor.
        </div>

        <v-layout wrap align-center class="mb-3">
          <v-flex xs12 sm3 class="pr-2">
            <v-select
              v-model="filters.userId"
              :items="userItems"
              item-text="name"
              item-value="id"
              label="Kullanıcı"
              prepend-icon="person"
              hide-details
              @change="load"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm3 class="pr-2">
            <v-menu v-model="startMenu" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="filters.startDate"
                  label="Başlangıç"
                  prepend-icon="event"
                  readonly
                  clearable
                  hide-details
                  v-on="on"
                  @click:clear="filters.startDate = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filters.startDate" locale="tr-TR" @input="startMenu = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3 class="pr-2">
            <v-menu v-model="endMenu" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="filters.endDate"
                  label="Bitiş"
                  prepend-icon="event"
                  readonly
                  clearable
                  hide-details
                  v-on="on"
                  @click:clear="filters.endDate = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filters.endDate" locale="tr-TR" @input="endMenu = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3 class="pl-2">
            <v-btn color="indigo darken-2" dark block class="lv-btn ma-0" :loading="loading" @click="load">
              <v-icon left small>filter_list</v-icon>
              Filtrele
            </v-btn>
          </v-flex>
        </v-layout>

        <v-tabs v-model="tab" grow slider-color="indigo darken-2">
          <v-tab>
            Bekleyenler
            <span v-if="pending.length" class="lv-tab-badge">{{ pending.length }}</span>
          </v-tab>
          <v-tab>Geçmiş</v-tab>

          <v-tab-item>
            <div class="pt-3">
              <div v-if="!pending.length" class="lv-empty">
                <v-icon large color="grey lighten-1">beach_access</v-icon>
                <div>Bekleyen izin talebi yok.</div>
              </div>
              <div v-else>
                <div class="lv-card lv-card--wait" v-for="item in pending" :key="'p-' + item.id">
                  <div class="lv-card-l">
                    <div class="lv-title">{{ item.userName }}</div>
                    <div class="lv-meta">
                      {{ formatDate(item.startDate) }} → {{ formatDate(item.endDate) }} ·
                      <span class="lv-chip lv-chip--wait">{{ item.dayCount }} gün</span>
                      · talep: {{ formatDateTime(item.createdDate) }}
                    </div>
                    <div class="lv-reason" v-if="item.reason">{{ item.reason }}</div>
                  </div>
                  <div class="lv-card-r">
                    <v-btn color="green darken-1" dark class="lv-btn ma-0 mr-2" @click="openDecideDialog(item, true)">
                      <v-icon small left>check</v-icon>
                      Onayla
                    </v-btn>
                    <v-btn color="red darken-1" dark class="lv-btn ma-0" @click="openDecideDialog(item, false)">
                      <v-icon small left>close</v-icon>
                      Reddet
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item>
            <div class="pt-3">
              <v-layout class="mb-2">
                <v-flex xs12 sm4>
                  <v-select
                    v-model="historyStatus"
                    :items="historyStatusItems"
                    item-text="label"
                    item-value="value"
                    label="Durum (tümü)"
                    prepend-icon="tune"
                    hide-details
                    clearable
                  ></v-select>
                </v-flex>
              </v-layout>

              <div v-if="!filteredHistory.length" class="lv-empty">
                <v-icon large color="grey lighten-1">history</v-icon>
                <div>Kayıt yok.</div>
              </div>
              <div v-else>
                <div
                  class="lv-card"
                  :class="historyCardClass(item.status)"
                  v-for="item in filteredHistory"
                  :key="'h-' + item.id"
                >
                  <div class="lv-card-l">
                    <div class="lv-title">{{ item.userName }}</div>
                    <div class="lv-meta">
                      {{ formatDate(item.startDate) }} → {{ formatDate(item.endDate) }} ·
                      <span class="lv-chip" :class="statusChipClass(item.status)">{{ item.statusText }}</span>
                      · <span class="lv-chip lv-chip--grey">{{ item.dayCount }} gün</span>
                    </div>
                    <div class="lv-reason" v-if="item.reason">{{ item.reason }}</div>
                    <div class="lv-decision" v-if="item.decidedByName">
                      {{ item.decidedByName }} · {{ formatDateTime(item.decidedDate) }}
                      <template v-if="item.adminNote"> — “{{ item.adminNote }}”</template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>

    <v-dialog v-model="decideDialog" max-width="440" persistent>
      <v-card>
        <v-card-title class="headline white--text" :class="decideApprove ? 'green darken-1' : 'red darken-1'">
          <v-icon left color="white">{{ decideApprove ? 'check_circle' : 'cancel' }}</v-icon>
          {{ decideApprove ? 'İzni Onayla' : 'İzni Reddet' }}
        </v-card-title>
        <v-card-text class="pa-4">
          <div v-if="decideItem" class="body-2 mb-3">
            <strong>{{ decideItem.userName }}</strong> —
            {{ formatDate(decideItem.startDate) }} → {{ formatDate(decideItem.endDate) }}
            <span class="lv-chip lv-chip--grey ml-1">{{ decideItem.dayCount }} gün</span>
            <div v-if="decideItem.reason" class="grey--text mt-2">{{ decideItem.reason }}</div>
          </div>
          <v-textarea
            v-model="decideNote"
            :label="decideApprove ? 'Not (opsiyonel)' : 'Red sebebi'"
            rows="2"
            counter="500"
            maxlength="500"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn flat color="grey" @click="decideDialog = false" :disabled="deciding">Vazgeç</v-btn>
          <v-btn :color="decideApprove ? 'green darken-1' : 'red darken-1'" dark class="lv-btn" :loading="deciding" @click="confirmDecide">
            {{ decideApprove ? 'Onayla' : 'Reddet' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from "@/api/baseApi";

export default {
  data: () => ({
    tab: null,
    loading: false,
    requests: [],
    users: [],
    filters: { userId: null, startDate: null, endDate: null },
    startMenu: false,
    endMenu: false,
    historyStatus: null,
    historyStatusItems: [
      { label: "Onaylandı", value: 1 },
      { label: "Reddedildi", value: 2 },
      { label: "İptal Edildi", value: 3 },
    ],
    decideDialog: false,
    decideApprove: true,
    decideItem: null,
    decideNote: "",
    deciding: false,
  }),

  computed: {
    leaveStats() {
      const list = this.requests || [];
      const gun = (r) => {
        if (!r.startDate || !r.endDate) return 0;
        const a = new Date(r.startDate);
        const b = new Date(r.endDate);
        const fark = Math.floor((b - a) / 86400000) + 1;
        return fark > 0 ? fark : 1;
      };
      return {
        total: list.length,
        pending: list.filter((r) => r.status === 0).length,
        approved: list.filter((r) => r.status === 1).length,
        rejected: list.filter((r) => r.status === 2).length,
        cancelled: list.filter((r) => r.status === 3).length,
        approvedDays: list.filter((r) => r.status === 1).reduce((t, r) => t + gun(r), 0),
      };
    },
    selectedUserName() {
      const u = (this.userItems || []).find((x) => x.id === this.filters.userId);
      return (u && u.id != null && u.name) || "seçili kullanıcı";
    },
    pending() {
      return this.requests.filter((r) => r.status === 0);
    },
    history() {
      return this.requests.filter((r) => r.status !== 0);
    },
    filteredHistory() {
      if (this.historyStatus == null) return this.history;
      return this.history.filter((r) => r.status === this.historyStatus);
    },
    userItems() {
      const liste = this.users.map((u) => ({
        id: u.id,
        name: `${u.firstName || ""} ${u.lastName || ""}`.trim() || u.username,
      }));
      liste.sort((a, b) => a.name.localeCompare(b.name, "tr"));
      return [{ id: null, name: "Tümü (bütün kullanıcılar)" }].concat(liste);
    },
  },

  async created() {
    await Promise.all([this.load(), this.loadUsers()]);
  },

  methods: {
    formatDate(d) {
      if (!d) return "-";
      return new Date(d).toLocaleDateString("tr-TR");
    },
    formatDateTime(d) {
      if (!d) return "";
      return new Date(d).toLocaleString("tr-TR");
    },
    statusChipClass(status) {
      if (status === 1) return "lv-chip--done";
      if (status === 2) return "lv-chip--red";
      return "lv-chip--grey";
    },
    historyCardClass(status) {
      if (status === 1) return "lv-card--done";
      if (status === 2) return "lv-card--red";
      return "lv-card--grey";
    },
    errMsg(e) {
      return (e.response && e.response.data && e.response.data.message) || e.message || "bilinmeyen hata";
    },
    async loadUsers() {
      try {
        this.users = (await Api.get("/api/users/all")).data || [];
      } catch (e) {
        this.users = [];
      }
    },
    async load() {
      this.loading = true;
      try {
        const params = {};
        if (this.filters.userId) params.userId = this.filters.userId;
        if (this.filters.startDate) params.startDate = this.filters.startDate;
        if (this.filters.endDate) params.endDate = this.filters.endDate;
        this.requests = (await this.$store.dispatch("leaves/getAdminList", params)) || [];
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "İzinler yüklenemedi: " + this.errMsg(e);
      } finally {
        this.loading = false;
      }
    },
    openDecideDialog(item, approve) {
      this.decideItem = item;
      this.decideApprove = approve;
      this.decideNote = "";
      this.decideDialog = true;
    },
    async confirmDecide() {
      if (!this.decideItem) return;
      this.deciding = true;
      try {
        const action = this.decideApprove ? "leaves/approve" : "leaves/reject";
        await this.$store.dispatch(action, { id: this.decideItem.id, note: this.decideNote });
        this.decideDialog = false;
        await this.load();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "İşlem başarısız: " + this.errMsg(e);
      } finally {
        this.deciding = false;
      }
    },
  },
};
</script>

<style scoped>
.lv-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(128px, 1fr));
  gap: 10px;
  margin-bottom: 12px;
}
.lv-stat {
  border: 1px solid #e5e9f0;
  border-left: 4px solid #b0bec5;
  border-radius: 8px;
  padding: 10px 14px;
  background: #fff;
}
.lv-stat--wait { border-left-color: #ff8f00; }
.lv-stat--ok { border-left-color: #2e7d32; }
.lv-stat--no { border-left-color: #c62828; }
.lv-stat--grey { border-left-color: #78909c; }
.lv-stat--day { border-left-color: #3949ab; }
.lv-stat-n {
  font-size: 22px;
  font-weight: 700;
  color: #263238;
  font-family: Menlo, Consolas, monospace;
  line-height: 1.25;
}
.lv-stat-u { font-size: 12px; color: #90a4ae; font-weight: 400; }
.lv-stat-l {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #90a4ae;
  font-weight: 600;
  margin-top: 2px;
}
.lv-scope {
  font-size: 12.5px;
  color: #5e35b1;
  background: #ede7f6;
  border: 1px solid #d1c4e9;
  border-radius: 6px;
  padding: 6px 10px;
  margin-bottom: 12px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.lv-card {
  border: 1px solid #e5e9f0;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 10px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.lv-card--wait {
  background: #fff8e1;
  border-color: #ffe082;
}
.lv-card--done {
  background: #e8f5e9;
  border-color: #a5d6a7;
}
.lv-card--red {
  background: #ffebee;
  border-color: #ffcdd2;
}
.lv-card--grey {
  background: #f6f8f9;
  border-color: #cfd8dc;
}
.lv-card-l {
  min-width: 0;
  padding-right: 12px;
}
.lv-card-r {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.lv-title {
  font-size: 17px;
  font-weight: 600;
  color: #263238;
}
.lv-meta {
  font-size: 12px;
  color: #78909c;
  margin-top: 2px;
}
.lv-reason {
  font-size: 12.5px;
  color: #546e7a;
  margin-top: 4px;
}
.lv-decision {
  font-size: 12px;
  color: #90a4ae;
  margin-top: 4px;
  font-style: italic;
}
.lv-chip {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 4px;
  font-family: Menlo, Consolas, monospace;
  font-size: 11px;
  font-weight: 600;
  vertical-align: middle;
}
.lv-chip--wait {
  background: #fff8e1;
  color: #b26a00;
  border: 1px solid #ffe082;
}
.lv-card--wait .lv-chip--wait {
  background: #ffecb3;
}
.lv-chip--done {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #c8e6c9;
}
.lv-card--done .lv-chip--done {
  background: #c8e6c9;
}
.lv-chip--red {
  background: #ffebee;
  color: #c62828;
  border: 1px solid #ffcdd2;
}
.lv-card--red .lv-chip--red {
  background: #ffcdd2;
}
.lv-chip--grey {
  background: #eceff1;
  color: #546e7a;
  border: 1px solid #cfd8dc;
}
.lv-btn {
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.4px;
  box-shadow: none;
}
.lv-tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  margin-left: 8px;
  border-radius: 10px;
  background: #ff8f00;
  color: #fff;
  font-weight: 700;
  font-size: 11px;
}
.lv-empty {
  text-align: center;
  padding: 40px 0;
  color: #90a4ae;
  font-size: 14px;
}
.lv-empty .v-icon {
  margin-bottom: 8px;
}
@media (max-width: 700px) {
  .lv-card {
    flex-direction: column;
    align-items: flex-start;
  }
  .lv-card-r {
    margin-top: 10px;
  }
}
</style>
